import { useState } from 'react';
import { resolveDefaultSubtitlesEnabled } from '@/lib/subtitles/resolveDefaultSubtitlesEnabled';

/**
 * Render subtitles toggle seeded from the loaded project/library's
 * `default_subtitles_enabled`. The default is applied once per source id, so a
 * refetch never overrides what the user toggled, and it is applied during
 * render so the first painted frame already has the right state.
 */
export function useSourceSubtitlesEnabled(source: { id?: string | null } | null | undefined) {
  const [appliedFor, setAppliedFor] = useState<string | null>(null);
  const [enabled, setEnabled] = useState(true);

  const sourceId = source?.id ?? null;
  if (sourceId && sourceId !== appliedFor) {
    setAppliedFor(sourceId);
    setEnabled(resolveDefaultSubtitlesEnabled(source));
  }

  return [enabled, setEnabled] as const;
}
